<sd-icon [type]="icon" class="color-black-warm"></sd-icon>
